/* Viral Supply — seamless one-at-a-time slider (clone loop, swipe, auto) */
(function () {
  function init(el) {
    if (el.dataset.vsReady) return;
    var track = el.querySelector('.vs-slider__track');
    if (!track) return;
    var real = Array.prototype.slice.call(track.children);
    var n = real.length;
    el.dataset.vsReady = '1';
    if (n <= 1) return;

    // clone last -> prepend, first -> append (for seamless wrap both ways)
    var firstClone = real[0].cloneNode(true);
    var lastClone = real[n - 1].cloneNode(true);
    firstClone.setAttribute('aria-hidden', 'true');
    lastClone.setAttribute('aria-hidden', 'true');
    track.insertBefore(lastClone, real[0]);
    track.appendChild(firstClone);

    var total = n + 2;
    var idx = 1; // first real slide

    function place(animate) {
      track.style.transition = animate ? '' : 'none';
      track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      if (!animate) { track.offsetHeight; track.style.transition = ''; }
    }
    place(false);

    track.addEventListener('transitionend', function (e) {
      if (e.propertyName && e.propertyName !== 'transform') return;
      if (idx === 0) { idx = n; place(false); }
      else if (idx === total - 1) { idx = 1; place(false); }
    });

    function next() { if (idx < total - 1) { idx++; place(true); } }
    function prev() { if (idx > 0) { idx--; place(true); } }

    var auto = parseInt(el.getAttribute('data-auto') || '0', 10), timer = null;
    function start() { if (!auto) return; stop(); timer = setInterval(next, auto); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', start);

    // optional arrows (if present)
    var nb = el.querySelector('.vs-slider__next'), pb = el.querySelector('.vs-slider__prev');
    if (nb) nb.addEventListener('click', function (e) { e.preventDefault(); next(); start(); });
    if (pb) pb.addEventListener('click', function (e) { e.preventDefault(); prev(); start(); });

    // swipe (pointer / touch)
    var vp = el.querySelector('.vs-slider__viewport') || el;
    var x0 = null, y0 = null, active = false;
    vp.addEventListener('pointerdown', function (e) { x0 = e.clientX; y0 = e.clientY; active = true; stop(); });
    vp.addEventListener('dragstart', function (e) { e.preventDefault(); });
    window.addEventListener('pointerup', function (e) {
      if (!active) return; active = false;
      if (x0 == null) { start(); return; }
      var dx = e.clientX - x0, dy = e.clientY - y0; x0 = null; y0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { if (dx < 0) next(); else prev(); }
      start();
    });

    start();
  }
  function boot() { document.querySelectorAll('.vs-slider').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('vs:reinit', boot);
})();